import React, {useState} from "react";
import styled from "@emotion/styled";
import mediaqueries from "@styles/media";

import Icons from "@icons";

const EmailSubscriptionForm: React.FC<{}> = () => {
  const [email, setEmail] = useState('');

  const submitSubscription = async (e) => {
    e.preventDefault();
    const endpoint = "https://moxhealth.us4.list-manage.com/subscribe/post-json";
    const params = `u=502e504c3a4726548374ba48d&id=4bb11b6340&c=?&EMAIL=${email}`;
    const requestConfig = {
      mode: 'no-cors' // TODO: remove it when the domain is allowed in order to get the response
    };
    const response = await fetch(`${endpoint}?${params}`, requestConfig);
    if (!response.ok) {
      // TODO: show a snackbar to the user with the error. Ej: the email is already register
      return;
    }
    // TODO: show a snackbar to the user with a success message.
  };

  const handleEmailChange = (e) => {
    const { value: email} = e.target;
    setEmail(email);
  };

  return (
    <>
      <EmailSubscriptionFormContainer onSubmit={submitSubscription}>
        <EmailSubscriptionInput type="email" placeholder="email address" name="EMAIL" onChange={handleEmailChange} required />
        <EmailSubscriptionSubmit type="submit">
          <Icons.RightArrowIcon fill="#ffffff" />
        </EmailSubscriptionSubmit>
      </EmailSubscriptionFormContainer>
    </>
  );
};

const EmailSubscriptionFormContainer = styled.form`
  display: flex;
  justify-content: space-between;
  padding: 13px 40px 13px 20px;
  border: 1px solid #ffffff;

  ${mediaqueries.desktop`
    padding: 12px 16px;
  `};
`;

const EmailSubscriptionInput = styled.input`
  width: 300px;
  border: none;
  background-color: transparent;
  font-size: 24px;
  line-height: 165%;
  letter-spacing: -.05em;
  color: #ffffff;

  ${mediaqueries.desktop`
    width: 100%;
    font-size: 18px;
  `};
`;

const EmailSubscriptionSubmit = styled.button`
  transition: .3s linear;
  
  &:hover {
    transform: translate3d(0,-2px,0);
  }
`;

export default EmailSubscriptionForm;
